const staticUrl = () => {
  let sUrl;
  const pathname = window.location.host.toLowerCase();
  const version = document.getElementById('ms_ayso_version').value;
  if (pathname.indexOf('thecoachingmanual.com') > -1) {
    sUrl = `https://cdn.thecoachingmanual.com/ms-ayso/${version}/`;
  } else if (pathname.indexOf('beans.youballer.io') > -1) {
    sUrl = `https://cdn.beans.youballer.io/ms-ayso/${version}/`;
  } else {
    sUrl = '/';
  }
  return sUrl;
};

export default staticUrl;



// WEBPACK FOOTER //
// ./library/js/modules/static-path.js